import React from 'react'
import PatientRpmDetailsView from '../../../PatientRpmDetailsView/Index'

const PatientRpmComponent = () => {
  return (
    <PatientRpmDetailsView/>
  )
}

export default PatientRpmComponent
